import React from 'react';
import '../../header/style/header.scss';
import '../style/snapfish.scss';

export const SnapfishHeaderNavigation = props => {
	if (!props.isVisible) return <span />;
	return (
		<div>
			<div className="snapfish-header-navigation-container">
				<div className="snapfish-header-left">
					<div className=" nav-detail-top-back header-back-button" onClick={props.backClick} />
				</div>
				<div className="header-item header-item-right hidden">
					<div className="header-icon select" />
					<div className="header-label">Select All</div>
				</div>
				<div className="header-item header-item-right hidden">
					<div className="header-label">View</div>
					<div className="header-icon header-caret caret" />
				</div>
			</div>
			<div>
				<div>{props.title}</div>
				<div>{props.description}</div>
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/snapfish/components/snapfish-header-navigation.jsx